/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import * as ReactDnD from 'react-dnd';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as Constants from '../constants';
import * as Utilities from '../utilities';
import { TicketForm } from './ticket_form.jsx';

class TicketListItem extends React.Component {
      static propTypes = {
          onChange: PropTypes.func,
          onDelete: PropTypes.func,
          onToggleTicketEditor: PropTypes.func,
          editorOpened: PropTypes.bool
      };

      constructor(props) {
        super(props);
        this.toggleEditForm = this.toggleEditForm.bind(this);
        this.closeForm = this.closeForm.bind(this);
        this.formChange = this.formChange.bind(this);
this.deleteTicket = this.deleteTicket.bind(this);
      }

      toggleEditForm(event) {
        if (typeof this.props.onToggleTicketEditor === 'function') {
          this.props.onToggleTicketEditor(this.props.ticket.id);
        }
        return event.preventDefault();
      }

      closeForm(event) {
        event.preventDefault();
        // Cause the editor to be closed
        return (typeof this.props.onToggleTicketEditor === 'function' ? this.props.onToggleTicketEditor(this.props.ticket.id, false) : undefined);
      }

      formChange(name, value, event) {
        return (typeof this.props.onChange === 'function' ? this.props.onChange(this.props.ticket.id, name, value, event) : undefined);
      }

      deleteTicket(event) {
        event.preventDefault();
        return (typeof this.props.onDelete === 'function' ? this.props.onDelete(this.props.ticket.id, event) : undefined);
      }

      render() {
        const ticket_form = this.props.editorOpened ?
          <TicketForm ticket={this.props.ticket}
                       settings={this.props.settings}
                       onClose={this.closeForm}
                       onChange={this.formChange} /> : undefined;

        const status = this.props.ticket.active ?
          'Active'
        :
          'Inactive';

        const classes = classNames(this.props.className,
          {'ticket-item-dragging': this.props.dragging});

        const price_details = this.props.ticket.donation ?
          (this.props.ticket.max_price === null) || (this.props.ticket.max_price === 0) ?
            `${Utilities.formatCurrency(this.props.ticket.min_price, this.props.settings.currency)} + donation`
          :
            `${Utilities.formatCurrency(this.props.ticket.min_price, this.props.settings.currency)} - ${Utilities.formatCurrency(this.props.ticket.max_price, this.props.settings.currency)}`

        :
          Utilities.formatCurrency(this.props.ticket.price, this.props.settings.currency);

        return this.props.connectDropTarget(this.props.connectDragPreview(<tbody>
          <tr className={classes}>
            <td width="41%">
              {this.props.connectDragSource(<i className="fa fa-bars drag-handle" aria-hidden="true"></i>)}
              {this.props.ticket.name}
              {this.props.debug && (
                <span>(#{this.props.ticket.id}, @{this.props.ticket.ticket_group_id},{this.props.ticket.position})</span>
              )}
            </td>
            <td width="13%">{status}</td>
            <td width="15%">
              {this.props.ticket.amount_sold || 0}
              {this.props.ticket.quantity_limit > 0 && ` / ${  this.props.ticket.quantity_limit * this.props.settings.instance_count}`}
            </td>
            <td width="20%">
              {price_details}
            </td>
            <td width="11%">
              <div className="text-right action_icon_button">
                <a href="#"
                   onClick={this.toggleEditForm}
                   title="Edit Ticket"
                   className="edit_button"><i className="localist-icon-edit-small"></i></a>
                <a href="#"
                   onClick={this.deleteTicket}
                   title="Remove Ticket"
                   className="deletex_button"><i className="localist-icon-trash-small"></i></a>
              </div>
            </td>
          </tr>
          {ticket_form}
        </tbody>
        )
        );
      }
    }


    // Drag and Drop configuration
    //
    // This component can be dragged, and is also a drop target to point out the
    // desired location

    // Drag source configuration
    const dragSpec = {
      beginDrag(props, monitor, component) {
        const item = { id: props.ticket.id };
        if (typeof props.onDragStart === 'function') {
          props.onDragStart(item);
        }
        return item;
      },

      endDrag(props, monitor, component) {
        if (monitor.didDrop()) {
          const result = monitor.getDropResult();
          return (typeof props.onDragFinish === 'function' ? props.onDragFinish({item: {id: props.ticket.id}, target_id: result.id, target_position: result.position, target_group_id: result.ticket_group_id}) : undefined);
        } 
          return (typeof props.onDragCancel === 'function' ? props.onDragCancel({id: props.ticket.id}) : undefined);
        
      }
    };

    const dragCollect = (connect, monitor) => ({
      isDragging: monitor.isDragging(),
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview()
    });

    // Drop target configuration
    const dropSpec = {
      drop: (props, monitor, component) => {
        return {id: props.ticket.id, position: props.ticket.position, ticket_group_id: props.ticket.ticket_group_id};
      },


      hover: (props, monitor, component) => {
        if (monitor.canDrop() && monitor.isOver({shallow: true})) {
          const item = monitor.getItem();
          if (item.id !== props.ticket.id) {
            return (typeof props.onDragUpdate === 'function' ? props.onDragUpdate(item, props.ticket.position, props.ticket.ticket_group_id) : undefined);
          }
        }
      }
    };

    const dropCollect = (connect, monitor) => ({
      hovered: monitor.isOver(),
      connectDropTarget: connect.dropTarget()
    });

const TicketListItemWithDrag = ReactDnD.DragSource(Constants.DRAG_TYPE_TICKET_CLASS, dragSpec, dragCollect)(TicketListItem);
export const TicketListItemContainer = ReactDnD.DropTarget(Constants.DRAG_TYPE_TICKET_CLASS, dropSpec, dropCollect)(TicketListItemWithDrag);